import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import LayoutTopBar from 'app/components/layout/LayoutTopBar';
import { Button, DropdownMenu, Icon } from '@kontentino/ui';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import InsightsLiteTopBarDatePicker from './InsightsLiteTopBarDatePicker';
import { useInsightsContainer } from 'components/insights/context';
import UserPermissionGate from 'components/UserPermissionGate';
import { ActionDropdownMenuItem } from 'app/components/actions/ActionDropdownMenuItem';
import { faShareNodes } from '@fortawesome/pro-regular-svg-icons/faShareNodes';
import SyncProfileInsightsButton from 'app/modules/insights/components/SyncProfileInsightsButton';
import InsightsLitePageSelector from './InsightsLitePageSelector';
import { useActions } from 'app/hooks/useActions';
import InsightLiteExportDropdown from './InsightLiteExportDropdown';

type Props = {};

const InsightsLiteTopBar: FC<Props> = () => {
  const { t } = useTranslation();
  const {
    pages,
    activeState,
    changeSelectedProfiles,
    filterState,
    changePreset,
    changeDateFilter,
  } = useInsightsContainer();

  const { profileActions } = useActions('add-new-dropdown');
  const selectedPageId = filterState.selectedProfiles[0];

  return (
    <LayoutTopBar shadow className="tw-justify-between">
      <div className="tw-flex tw-gap-x-2">
        <InsightsLitePageSelector
          pages={pages}
          selectedPageId={selectedPageId}
          onSelectPage={changeSelectedProfiles}
        />
        <InsightsLiteTopBarDatePicker
          initialPreset={filterState.datePreset}
          startDate={filterState.startDate}
          endDate={filterState.endDate}
          onChange={(dates, preset) => {
            changeDateFilter(dates, false);
            changePreset(preset);
          }}
          dataName={{
            picker: 'insights-lite_date-picker',
            placeholder: 'insights-lite_date-picker_placeholder',
          }}
        />
      </div>
      <div className="tw-flex tw-gap-x-2">
        {activeState.page && (
          <>
            <InsightLiteExportDropdown />
            <SyncProfileInsightsButton page={activeState.page} />
          </>
        )}

        <div className="tw-ml-auto tw-flex tw-flex-1 tw-items-center tw-justify-end">
          <DropdownMenu.Root>
            <DropdownMenu.Trigger>
              <Button
                className="tw-h-[36px] tw-capitalize"
                variant="primary"
                data-name="insights-lite-add-new"
                data-cy="insights-lite-add-new-dropdown"
                iconAfter={<Icon icon={faChevronDown} />}
              >
                {t('new')}
              </Button>
            </DropdownMenu.Trigger>
            <DropdownMenu.Content>
              <UserPermissionGate scopes={profileActions.add.scopes}>
                <ActionDropdownMenuItem
                  data-name="insights-lite-add-new-profile"
                  action={profileActions.add}
                >
                  <Icon icon={faShareNodes} />
                  {t('profile')}
                </ActionDropdownMenuItem>
              </UserPermissionGate>
            </DropdownMenu.Content>
          </DropdownMenu.Root>
        </div>
      </div>
    </LayoutTopBar>
  );
};

export default InsightsLiteTopBar;
